import o from "./index171.js";
/* empty css         */
import t from "./index130.js";
const r = /* @__PURE__ */ t(o, [["__scopeId", "data-v-288d8ffb"]]);
export {
  r as default
};
